// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8193a9b1","453":"99198749"}[chunkId] + ".chunk.js";
};